import { request } from "./request.js";

async function get(key) {
    return await request("/duty", { key: key }, "POST");
}

async function save(data) {
    return await request("/duty/save", data, "POST");
}

async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/doctor/list" + append, {}, "POST");
}

export { save, get, list };
